import {Injectable} from '@angular/core';
import {VisbosService} from '../../core/visbos-core/graphql/visbos.service';
import {Apollo, ApolloQueryObservable} from 'apollo-angular';
import {NgRedux} from '@angular-redux/store';
import {IAppState} from '../../shared/redux-store';
import {SessionActions} from '../../shared/actions';
import {
  CreateAccountMutation,
  DeleteAccountMutation,
  FetchAccountingUnitsQuery,
  FetchAccountsQueryQuery,
  UpdateAccountMutation
} from '../../shared/graphql/graphql.types';
import gql from 'graphql-tag';
import {Observable} from 'rxjs';
import {ApolloQueryResult} from 'apollo-client';

export const accountFragments = {
  account: gql`
    fragment AccountFields on Account {
      cuid created_at updated_at label is_editable
      account_name account_number clearing_account_number
    }`
};

export const getAccountsQuery = gql`
  query FetchAccountsQuery {
    accounts {
      ...AccountFields
    }
  }
  ${accountFragments.account}
`;

export const createAccountMutation = gql`
  mutation CreateAccount($data: AccountInput!) {
    createAccount(data: $data) {
      ...AccountFields
    }
  }
  ${accountFragments.account}
`;

export const updateAccountMutation = gql`
  mutation UpdateAccount($cuid: String!, $data: AccountInput!) {
    updateAccount(cuid: $cuid, data: $data) {
      ...AccountFields
    }
  }
  ${accountFragments.account}
`;

export const deleteAccountMutation = gql`
  mutation DeleteAccount($cuid: String!) {
    deleteAccount(cuid: $cuid)
  }
`;

export const fetchAccountingUnitsQuery = gql`
  query FetchAccountingUnits($adminUnitCuid: String) {
    clients(adminUnitCuid: $adminUnitCuid) {cuid label __typename}
    fetchAdminUnits {cuid label __typename}
    vehicles(administration_unit_cuid: $adminUnitCuid) {cuid label __typename}
  }
`;

@Injectable()
export class AccountingUnitService extends VisbosService {

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  getAccountingUnits(adminUnitCuid?): ApolloQueryObservable<FetchAccountingUnitsQuery> {
    return this.fetchItems({
      query: fetchAccountingUnitsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$
      }
    });
  }

  getAccounts(): ApolloQueryObservable<FetchAccountsQueryQuery> {
    return this.fetchItems({
      query: getAccountsQuery
    });
  }

  createAccount(accountData): Observable<ApolloQueryResult<CreateAccountMutation>> {
    return this.mutate({
      mutation: createAccountMutation,
      variables: {
        data: accountData
      },
      refetchQueries: ['FetchAccountsQuery']
    });
  }

  updateAccount(cuid: string, accountData): Observable<ApolloQueryResult<UpdateAccountMutation>> {
    return this.mutate({
      mutation: updateAccountMutation,
      variables: {
        cuid: cuid,
        data: accountData
      }
    });
  }

  deleteAccount(cuid: string): Observable<ApolloQueryResult<DeleteAccountMutation>> {
    return this.mutate({
      mutation: deleteAccountMutation,
      variables: {
        cuid: cuid
      },
      refetchQueries: ['FetchAccountsQuery']
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/services/accounting-unit.service.ts